// extracted by mini-css-extract-plugin
export default {"themes":"ThemesList_themes__w3HN+","point":"ThemesList_point__BRBZE"};